import { AscButtonShareCommonPropsI } from "../AscButtonShare.type";
import styles from "./AscButtonShareFacebook.module.scss";
import classNames from "classnames";
import { FacebookWhiteIcon } from "../../AscIcons";

function AscButtonShareFacebook({
  className,
  label = "Facebook",
  link,
}: AscButtonShareCommonPropsI) {
  return (
    <button
      className={classNames(className, styles.element)}
      data-sharer="facebook"
      data-hashtag="ascend,certificate"
      data-url={link}
    >
      <FacebookWhiteIcon className={styles.icon} />
      {label}
    </button>
  );
}

export default AscButtonShareFacebook;
